import { GitFork, Megaphone, MessageSquare, SquarePlay } from "lucide-react";
import teamImage from "../../assets/images/whatwedo/eventsExperiences/eventsServices/01.jpg";
import promotionImage from "../../assets/images/eventsExperiences/services/talent.jpg";
import contentImage from "../../assets/images/eventsExperiences/services/content.jpg";
import contactImage from "../../assets/images/whatwedo/eventsExperiences/oneMan.jpg";

const REASONS = [
  { icon: GitFork, image: teamImage, title: "One Team, One Plan", desc: "Planning, production, vendors and promotion sit together, so nothing gets lost in hand-offs." },
  { icon: Megaphone, image: promotionImage, title: "Promotion Built In", desc: "Creators and social content support the event before, during and after, not just on the day." },
  { icon: SquarePlay, image: contentImage, title: "Content From the Moment", desc: "Our media team is on site, so the best moments become posts and videos while they are still fresh." },
  { icon: MessageSquare, image: contactImage, title: "One Point of Contact", desc: "A single person who knows your brief and answers when you call." },
];

// Hover tilt + glare: the card leans toward the cursor and a soft light follows it.
// Written straight to CSS variables so mouse moves don't re-render React.
const tilt = (e) => {
  const el = e.currentTarget;
  const r = el.getBoundingClientRect();
  const x = (e.clientX - r.left) / r.width;
  const y = (e.clientY - r.top) / r.height;
  el.style.setProperty("--tilt-y", `${(x - 0.5) * 16}deg`);
  el.style.setProperty("--tilt-x", `${(0.5 - y) * 12}deg`);
  el.style.setProperty("--glare-x", `${x * 100}%`);
  el.style.setProperty("--glare-y", `${y * 100}%`);
};

const untilt = (e) => {
  e.currentTarget.style.setProperty("--tilt-y", "0deg");
  e.currentTarget.style.setProperty("--tilt-x", "0deg");
};

const EventsWhy = () => (
  <section className="ee-section ee-why">
    <div className="container">
      <header className="ee-why-heading">
        <span className="ee-eyebrow">Events & Experiences</span>
        <h2 className="ee-title">Why HKI Media?</h2>
        <p className="ee-why-intro">An event is only half the job. The reach is the other half.</p>
      </header>
      <div className="ee-why-grid">
        {REASONS.map(({ icon: Icon, image, title, desc }, index) => (
          <div className="ee-why-slot" key={title} data-aos="fade-up" data-aos-delay={index * 100} data-aos-once="true">
            <article className="ee-why-card" onMouseMove={tilt} onMouseLeave={untilt}>
              <img className="ee-why-card-image" src={image} alt="" loading="lazy" />
              <span className="ee-why-num" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
              <div className="ee-why-card-body">
                <span className="ee-why-icon"><Icon size={19} strokeWidth={1.8} aria-hidden="true" /></span>
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
            </article>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default EventsWhy;
